<div class="flex-1 mr-5">
	<h2>Other - {{ adjustment.otherType | capitalize }} amount</h2>
	<app-input
		label="Adjustment title"
		[(ngModel)]="adjustment.title"
		class="mt-5"
	></app-input>

	<div class="flex justify-start">
		<app-radio-group
			class="mt-3"
			[items]="otherTypesOptions"
			label="Type"
			name="type"
			[(ngModel)]="adjustment.otherType"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
	</div>

	<div *ngIf="adjustment.otherType === otherTypes.PRORATED" [@openClose]>
		<div class="flex justify-start">
			<app-radio-group
				class="mt-3"
				[items]="vendorOptions"
				label="Vendor"
				name="vendor"
				[(ngModel)]="adjustment.vendor"
				(ngModelChange)="changed()"
				type="compact"
			></app-radio-group>
		</div>

		<app-date-picker
			label="Start date of current rental period"
			class="mt-3"
			[(ngModel)]="adjustment.startDate"
			(ngModelChange)="changed()"
			maxDate="{{ maxStartDate }}"
			maxDateErrorLabel="{{ maxStartDateLabel }}"
			[submitted]="formSubmitted"
			[required]="true"
		></app-date-picker>

		<app-date-picker
			label="End date of current rental period"
			class="mt-3"
			[(ngModel)]="adjustment.endDate"
			(ngModelChange)="changed()"
			minDate="{{ adjustment.startDate }}"
			minDateErrorLabel="the Start Date"
			[submitted]="formSubmitted"
			[required]="true"
		></app-date-picker>

		<app-input
			type="cents"
			[startIcon]="ICON.DOLLAR"
			label="Amount to be prorated"
			class="mt-3"
			[(ngModel)]="adjustment.proratedAmount"
			(ngModelChange)="changed()"
		></app-input>

		<div class="flex justify-start">
			<app-radio-group
				class="mt-3"
				[items]="yesNoOptions"
				[label]="vendorReceivedLabel"
				name="vendorReceived"
				[(ngModel)]="adjustment.paidInFull"
				(ngModelChange)="changed()"
				type="compact"
			></app-radio-group>
		</div>

		<app-input
			class="mt-3"
			*ngIf="!adjustment.paidInFull"
			type="cents"
			[label]="vendorShareLabel"
			[startIcon]="ICON.DOLLAR"
			[(ngModel)]="adjustment.amountPaid"
			(ngModelChange)="changed()"
		></app-input>
	</div>

	<div *ngIf="adjustment.otherType === otherTypes.FIXED" [@openClose]>
		<div class="flex justify-start">
			<app-radio-group
				class="mt-3"
				[items]="creditOptions"
				label="Credit"
				name="credit"
				[(ngModel)]="adjustment.credit"
				(ngModelChange)="setAdjustmentCredit($event)"
				type="compact"
			></app-radio-group>
		</div>

		<app-input
			class="mt-3"
			type="cents"
			label="Amount"
			[(ngModel)]="adjustment.amount"
			[startIcon]="ICON.DOLLAR"
			(ngModelChange)="changed()"
		></app-input>
	</div>

	<div class="mt-3 flex justify-start">
		<app-checkbox
			label="Apply HST"
			[(ngModel)]="adjustment.applyHst"
			(ngModelChange)="changed()"
		></app-checkbox>
	</div>

	<div class="mt-5 flex justify-start">
		<app-checkbox
			label="Include all details in document"
			[(ngModel)]="adjustment.details"
		></app-checkbox>
	</div>

	<div class="flex justify-between mt-5">
		<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
			>Cancel</app-button
		>
		<app-button (click)="saveModal()" size="small">Save</app-button>
	</div>
</div>
<div class="flex-1 ml-5">
	<app-container title="Details" type="dark">
		<div *ngIf="adjustment?.otherType === otherTypes.FIXED">
			<div *ngIf="adjustment?.credit === creditTypes.NONE">No adjustment</div>
			<div
				class="flex flex-col gap-2"
				*ngIf="adjustment.credit !== creditTypes.NONE"
			>
				<div class="flex justify-between">
					<span>
						{{ adjustment?.title }}
					</span>
					<span>
						{{ adjustment?.amount | centsToDollars }}
					</span>
				</div>
				<div class="flex justify-between" *ngIf="adjustment?.applyHst">
					<span> HST of {{ calculation?.hst * 100 }}% on fee </span>
					<span>
						{{ calculation?.hstAmount | centsToDollars }}
					</span>
				</div>
				<div class="flex justify-end font-bold">
					<span
						>Credit
						{{
							calculation?.creditAmount > 0
								? 'Vendor'
								: calculation?.creditAmount == 0
									? calculation?.adjustment?.credit === 'purchaser'
										? 'Purchaser'
										: 'Vendor'
									: 'Purchaser'
						}}
						= {{ calculation?.absAmount | centsToDollars }}</span
					>
				</div>
			</div>
		</div>

		<div *ngIf="adjustment?.otherType === otherTypes.PRORATED">
			<div *ngIf="!adjustment?.startDate || !adjustment?.endDate">
				Select start and end dates of the current rental period.
			</div>

			<ng-container *ngIf="adjustment?.startDate && adjustment?.endDate">
				<div class="flex flex-col gap-2">
					<div class="flex justify-between">
						<span>
							{{ adjustment?.title }} ({{ calculation?.totalPeriodDays }} days)
						</span>
						<span>
							{{ adjustment?.proratedAmount | centsToDollars }}
						</span>
					</div>
					<div class="flex justify-between" *ngIf="adjustment?.applyHst">
						<span> HST of {{ calculation?.hst * 100 }}% on fee </span>
						<span>
							{{ calculation?.hstAmount | centsToDollars }}
						</span>
					</div>
					<div>
						For the period of
						{{ adjustment?.startDate | date: 'mediumDate' }} to
						{{ adjustment?.endDate | date: 'mediumDate' }}
					</div>

					<div class="flex justify-between">
						<span>
							Vendors share for {{ calculation?.vendorDaysCoverage }} days
						</span>
						<span>
							{{ calculation?.vendorAmountCoverage | centsToDollars }}
						</span>
					</div>

					<div class="flex justify-between">
						<span> Vendor paid </span>
						<span>
							{{ calculation?.paidAmount | centsToDollars }}
						</span>
					</div>

					<div class="flex justify-end font-bold">
						<span
							>Credit
							{{
								calculation?.creditAmount < 0 ||
								(calculation?.creditAmount == 0 &&
									calculation?.adjustment?.credit === 'purchaser')
									? 'Purchaser'
									: 'Vendor'
							}}
							= {{ calculation?.absAmount | centsToDollars }}</span
						>
					</div>
				</div>
			</ng-container>
		</div>
	</app-container>
</div>
